import { suppliersAPI } from 'api/supplier/suppliersAPI'
import { useState } from 'react'

export default function useSupplier() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const updateSupplier = async (data: any, id: number) => {
    setIsLoading(true)
    setError(false)

    try {
      const resp = await suppliersAPI.updateSupplier(data, id)

      if (resp && resp.data?.error) {
        setError(true)
      }
    } catch (error) {
      setError(true)
    }

    setIsLoading(false)
  }

  return { updateSupplier, isLoading, error }
}
